<div class="container">
  <div class="row">
    <div class="card" style="width: 100%">
      <div class="card-body">
        @if (enableLtssLettersSwitch) {
        <nav
          class="d-lg-block"
          [attr.aria-label]="'LETTERS_NAVIGATION' | globalTranslate"
        >
          <ul
            class="nav nav-tabs nav-justified nav-fill flex-lg-row tab-height"
          >
            <li class="nav-item item-height">
              <a
                class="nav-link d-flex flex-row justify-content-center p-0 link-height"
                routerLinkActive="active"
                [routerLink]="['my-letters']"
                ><span class="tab-section">{{
                  "ELIGIBILITY_LETTERS" | globalTranslate
                }}</span></a
              >
            </li>
            <li class="nav-item item-height">
              <a
                class="nav-link d-flex flex-row justify-content-center p-0 pe-1 link-height"
                [routerLink]="['ltss-letters']"
                routerLinkActive="active"
              >
                <span class="tab-section">
                  @if (currentLang !== 'en' && globalLang === null) {
                  {{ "LTSS_LETTERS" | globalTranslate }} {{ "LTSS" }}
                  } @else {
                  {{ "LTSS" }} {{ "LTSS_LETTERS" | globalTranslate }}
                  }
                </span></a
              >
            </li>
          </ul>
        </nav>
        }
        <div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>